import { render } from "./CreatePrizeDrawClient.vue?vue&type=template&id=21d5f8a5"
import script from "./CreatePrizeDrawClient.vue?vue&type=script&lang=js"
export * from "./CreatePrizeDrawClient.vue?vue&type=script&lang=js"

import "./CreatePrizeDrawClient.vue?vue&type=style&index=0&id=21d5f8a5&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__